export default (publicKey, payMethod) => {
    return publicKey?.[Object.keys(publicKey)?.find(key => key?.split(',')?.some(k => k === payMethod))]
}